import { useMemo, useRef, useState } from "react";

import { useTranslation } from "react-i18next";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";

import PRButton from "~components/Generic/PRButton";
import PRContainer from "~components/Generic/PRContainer";
import PRTable from "~components/Generic/PRTable";
import { apiUrlUserUnderstanding } from "~constants";
import DialogHelper from "~helpers/DialogHelper";
import { selectCurrentBot, selectCurrentProject } from "~store/user/selectors";
import { deleteUserUnderstanding } from "~store/userUnderstanding/actions";

const UserPurposeList = () => {
  const { t } = useTranslation();
  const tableRef = useRef();
  const dispatch = useDispatch();
  const currentProject = useSelector(selectCurrentProject);
  const currentBot = useSelector(selectCurrentBot);
  const [tableCount, setTableCount] = useState(0);

  const columns = useMemo(() => {
    const handleClickDelete = (item) => async () => {
      if (!(await DialogHelper.showQuestionYesNo(t("common.delete"), t("dashboard.userPurpose.deleteQuestion"))))
        return;
      // TODO: Delete User Purpose
      await dispatch(deleteUserUnderstanding(currentProject.id, currentBot.id, item.id));

      tableRef.current?.refresh();
    };
    return [
      {
        label: t("common.id"),
        key: "id",
      },
      {
        label: t("common.name"),
        key: "name",
      },
      {
        label: t("common.description"),
        key: "description",
      },
      {
        label: t("dashboard.userPurpose.emoji"),
        key: "emoji",
      },
      {
        label: t("common.actions"),
        key: "actions",
        fixed: "right",
        actions: true,
        render: (row) => (
          <div className="d-flex justify-content-center gap-1">
            <PRButton
              outline
              color="primary"
              icon={MdEdit}
              link={`/chatbot/user-understanding/purpose/form/${row.id}`}
              size="sm"
              tooltipText={t("dashboard.userPurpose.editTooltip")}
            />
            <PRButton
              outline
              color="danger"
              icon={MdDelete}
              size="sm"
              tooltipText={t("common.delete")}
              onClick={handleClickDelete(row)}
            />
          </div>
        ),
      },
    ];
  }, [t, dispatch, currentProject.id, currentBot.id]);

  const actions = useMemo(
    () => [
      {
        label: t("common.create"),
        icon: MdAdd,
        color: "success",
        link: "/chatbot/user-understanding/purpose/form",
        disabled: tableCount >= 10, // Assuming a maximum of 10 user purposes
      },
    ],
    [t, tableCount]
  );

  const parentName = [
    {
      label: t("dashboard.userPurpose"),
    },
  ];

  return (
    <PRContainer
      actions={actions}
      description={t("dashboard.userPurpose.description")}
      name={t("common.chatbot")}
      parentName={parentName}
    >
      <div className="mt-2">
        <PRTable
          ref={tableRef}
          columns={columns}
          url={apiUrlUserUnderstanding.get.format(currentProject.id, currentBot.id) + "?class_type=1"}
          onCountChange={setTableCount}
        />
      </div>
    </PRContainer>
  );
};

export default UserPurposeList;
